<template xmlns:v-bind="http://www.w3.org/1999/xhtml" xmlns:v-el="http://www.w3.org/1999/xhtml">
  <svg
    viewBox="0 0 180 146"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 64 (93537) - https://sketch.com -->
    <title>retail-banking-customers</title>
    <desc>Created with Sketch.</desc>
    <g
      id="Page-1"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd">
      <g
        id="Desktop-HD"
        transform="translate(-605.000000, -41.000000)">
        <g
          id="retail-banking-customers"
          transform="translate(606.000000, 41.000000)">
          <g id="Background">
            <path
              id="Path"
              d="M167.000033,80 C166.99694,47.3292213 147.128034,17.9430147 116.810166,5.76899817 C86.4922977,-6.40501831 51.8180575,1.07960967 29.2213312,24.6755362 C6.62460481,48.2714628 0.64636355,83.2369203 14.12,113 L159.88,113 C164.582525,102.634613 167.010315,91.3822174 167.000033,80 Z"
              class="fill-extra-light"
              fill-rule="nonzero" />
            <line
              id="Path"
              x1="9"
              y1="113"
              x2="165"
              y2="113"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="0"
              y1="113"
              x2="5"
              y2="113"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="169"
              y1="113"
              x2="174"
              y2="113"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
          <g
            id="_Layer_"
            transform="translate(35.000000, 12.000000)">
            <ellipse
              id="Oval"
              class="fill-extra-light"
              fill-rule="nonzero"
              cx="23.16"
              cy="129.56"
              rx="23"
              ry="3.46" />
            <g
              id="Group"
              transform="translate(50.000000, 17.000000)">
              <path
                id="Path"
                d="M4.9,32 L88.9,32 L88.9,40 C88.9,41.1045695 88.0045695,42 86.9,42 L6.9,42 C5.7954305,42 4.9,41.1045695 4.9,40 L4.9,32 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <rect
                id="Rectangle"
                class="fill-white"
                fill-rule="nonzero"
                x="8.9"
                y="42"
                width="76"
                height="42" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="8.9"
                y="42"
                width="76"
                height="42" />
              <rect
                id="Rectangle"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="18.9"
                y="76"
                width="56"
                height="8" />
              <path
                id="Path"
                d="M8.9,74 L16.9,74 C18.0045695,74 18.9,74.8954305 18.9,76 L18.9,84 L6.9,84 L6.9,76 C6.9,74.8954305 7.7954305,74 8.9,74 Z"
                class="fill-white"
                fill-rule="nonzero" />
              <path
                id="Path"
                d="M8.9,74 L16.9,74 C18.0045695,74 18.9,74.8954305 18.9,76 L18.9,84 L6.9,84 L6.9,76 C6.9,74.8954305 7.7954305,74 8.9,74 Z"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M76.9,74 L86.9,74 L86.9,84 L74.9,84 L74.9,76 C74.9,74.8954305 75.7954305,74 76.9,74 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="18.9"
                y1="80"
                x2="74.9"
                y2="80"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="fill-white"
                fill-rule="nonzero"
                x="8.9"
                y="48"
                width="8"
                height="26" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="8.9"
                y="48"
                width="8"
                height="26" />
              <rect
                id="Rectangle"
                class="fill-white"
                fill-rule="nonzero"
                x="76.9"
                y="48"
                width="8"
                height="26" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="76.9"
                y="48"
                width="8"
                height="26" />
              <rect
                id="Rectangle"
                class="fill-white"
                fill-rule="nonzero"
                x="26.9"
                y="48"
                width="8"
                height="22" />
              <path
                id="Path"
                d="M26.9,70 L34.9,70 C36.0045695,70 36.9,70.8954305 36.9,72 L36.9,76 L24.9,76 L24.9,72 C24.9,70.8954305 25.7954305,70 26.9,70 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M58.9,70 L66.9,70 C68.0045695,70 68.9,70.8954305 68.9,72 L68.9,76 L56.9,76 L56.9,72 C56.9,70.8954305 57.7954305,70 58.9,70 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M52.9,68 C52.9,64.6862915 50.2137085,62 46.9,62 C43.5862915,62 40.9,64.6862915 40.9,68 L40.9,76 L52.9,76 L52.9,68 Z"
                class="stroke fill-light"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <line
                id="Path"
                x1="46.9"
                y1="62"
                x2="46.9"
                y2="76"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M4.9,32 L88.9,32 L88.9,40 C88.9,41.1045695 88.0045695,42 86.9,42 L6.9,42 C5.7954305,42 4.9,41.1045695 4.9,40 L4.9,32 Z"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M90.88,24.86 L48.88,1.12 C47.6423957,0.40546882 46.1176043,0.40546882 44.88,1.12 L2.88,24.86 C1.63746323,25.5773639 0.874303975,26.905261 0.879968336,28.34 L0.879968336,30 C0.879968336,31.1045695 1.7754305,32 2.88,32 L92.8800317,32 L92.8800317,28.34 C92.885696,26.905261 92.1225368,25.5773639 90.88,24.86 L90.88,24.86 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <polygon
                id="Path"
                class="fill-white"
                fill-rule="nonzero"
                points="12.9 26 80.9 26 46.9 8" />
              <polygon
                id="Path"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                points="12.9 26 80.9 26 46.9 8" />
              <path
                id="Path"
                d="M42.32,22 C41.6733842,21.9974276 41.0679086,21.6823946 40.6947015,21.1543463 C40.3214945,20.626298 40.22661,19.950396 40.44,19.34 C41.5217202,16.7206261 44.0760561,15.0119094 46.91,15.0119094 C49.7439439,15.0119094 52.2982798,16.7206261 53.38,19.34 C53.59339,19.950396 53.4985055,20.626298 53.1252985,21.1543463 C52.7520914,21.6823946 52.1466158,21.9974276 51.5,22 L42.32,22 Z"
                class="stroke fill-light"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M6.9,42 L18.9,42 L18.9,46 C18.9,47.1045695 18.0045695,48 16.9,48 L8.9,48 C7.7954305,48 6.9,47.1045695 6.9,46 L6.9,42 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M24.9,42 L36.9,42 L36.9,46 C36.9,47.1045695 36.0045695,48 34.9,48 L26.9,48 C25.7954305,48 24.9,47.1045695 24.9,46 L24.9,42 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M56.9,42 L68.9,42 L68.9,46 C68.9,47.1045695 68.0045695,48 66.9,48 L58.9,48 C57.7954305,48 56.9,47.1045695 56.9,46 L56.9,42 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <path
                id="Path"
                d="M74.9,42 L86.9,42 L86.9,48 L76.9,48 C75.7954305,48 74.9,47.1045695 74.9,46 L74.9,42 Z"
                class="stroke fill-white"
                stroke-width="2"
                fill-rule="nonzero"
                stroke-linecap="round"
                stroke-linejoin="round" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="26.9"
                y="48"
                width="8"
                height="22" />
              <rect
                id="Rectangle"
                class="fill-white"
                fill-rule="nonzero"
                x="58.9"
                y="48"
                width="8"
                height="22" />
              <rect
                id="Rectangle"
                class="stroke"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                x="58.9"
                y="48"
                width="8"
                height="22" />
            </g>
            <path
              id="Path"
              d="M41.4,35.26 C42.7125791,34.5810714 43.5820678,33.273058 43.7,31.8 C43.6422788,29.0533406 41.7613392,26.681721 39.1,26 L39.1,16.8 C39.1000001,11.0480239 36.0313575,5.73297879 31.0500001,2.85699072 C26.0686427,-0.0189973578 19.9313573,-0.0189973578 14.9499999,2.85699072 C9.96864252,5.73297879 6.89999988,11.0480239 6.9,16.8 L6.9,26 C4.25960552,26.675612 2.38416199,29.0158393 2.3,31.74 C2.41793223,33.213058 3.28742089,34.5210714 4.6,35.1999997 C4.6,35.1999997 -2.13162821e-14,38.64 2.3,43.1999997 C4.6,47.76 10.3,47.8 10.3,47.8 C10.3,47.8 12.6,53.56 22.94,53.56 C33.28,53.56 35.66,48 35.66,48 C35.66,48 41.4,48 43.66,43.4 C45.92,38.8 41.4,35.26 41.4,35.26 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M39.1,24.9 C39.08659,23.5503433 38.125113,22.3965709 36.8,22.14 L36.8,20.3 C36.8,12.6784705 30.6215295,6.5 23,6.5 C15.3784705,6.5 9.2,12.6784705 9.2,20.3 L9.2,22.14 C7.81620012,22.4022745 6.83809008,23.6453365 6.90867545,25.0520019 C6.97926081,26.4586674 8.07689595,27.5975701 9.48,27.72 C10.832969,34.107114 16.4711601,38.6760866 23,38.6760866 C29.5288399,38.6760866 35.167031,34.107114 36.52,27.72 C37.9785079,27.5859175 39.0958357,26.3646522 39.1,24.9 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="15.52"
              cy="26.62"
              r="1.72" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="30.48"
              cy="26.62"
              r="1.72" />
            <path
              id="Path"
              d="M26.46,30.66 C24.4100965,32.1768677 21.6099035,32.1768677 19.56,30.66"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M17.82,20.3 C17.1144257,20.3000466 16.4787299,20.7261806 16.210625,21.3788328 C15.94252,22.031485 16.0950896,22.7814329 16.5968815,23.2774571 C17.0986734,23.7734812 17.850335,23.917371 18.4998442,23.6417391 C19.1493533,23.3661072 19.56811,22.7255277 19.56,22.02 C19.5490435,21.0668441 18.7732189,20.299937 17.82,20.3 L17.82,20.3 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M28.18,20.3 C27.2255477,20.3441594 26.4852597,21.1496915 26.5216828,22.1044703 C26.5581059,23.0592491 27.3576123,23.8060408 28.3126549,23.7773564 C29.2676976,23.7486719 30.0209439,22.9552437 30,22 C29.9891942,21.0545823 29.2254177,20.2908058 28.28,20.28 L28.18,20.3 Z"
              fill="#0066A4"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M39.1,24.9 L39.1,16.9 C39.1,11.1480239 36.0313575,5.83297879 31.0500001,2.95699072 C26.0686427,0.0810026422 19.9313573,0.0810026422 14.9499999,2.95699072 C9.96864252,5.83297879 6.9,11.1480239 6.9,16.9 L6.9,24.9 C6.90558597,23.5474794 7.87065921,22.3893915 9.2,22.14 L9.2,20.2999997 C9.2,20.2999997 27.6,22.6 30,10 C30,10 32.3,20.34 36.9,20.34 L36.9,22.18 C38.1750578,22.4672799 39.0856143,23.5930588 39.1,24.9 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M11.08,31.8 C11.08,33.0702549 10.0502549,34.1 8.78,34.1 C7.50974508,34.1 6.48,33.0702549 6.48,31.8 L6.48,29.5 C6.48,28.2297451 7.50974508,27.2 8.78,27.2 C10.0502549,27.2 11.08,28.2297451 11.08,29.5 L11.08,31.8 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M39.52,31.8 C39.52,33.0702549 38.4902549,34.1 37.22,34.1 C35.9497451,34.1 34.92,33.0702549 34.92,31.8 L34.92,29.5 C34.92,28.2297451 35.9497451,27.2 37.22,27.2 C38.4902549,27.2 39.52,28.2297451 39.52,29.5 L39.52,31.8 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M39.1,24.9 L39.1,16.9 C39.1,11.1480239 36.0313575,5.83297879 31.0500001,2.95699072 C26.0686427,0.0810026422 19.9313573,0.0810026422 14.9499999,2.95699072 C9.96864252,5.83297879 6.9,11.1480239 6.9,16.9 L6.9,24.9 C6.90558597,23.5474794 7.87065921,22.3893915 9.2,22.14 L9.2,20.2999997 C9.2,20.2999997 27.6,22.6 30,10 C30,10 32.3,20.34 36.9,20.34 L36.9,22.18 C38.1750578,22.4672799 39.0856143,23.5930588 39.1,24.9 Z"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <polygon
              id="Path"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              points="12.64 111.16 14.94 128.4 31.06 128.4 33.34 111.16" />
            <path
              id="Path"
              d="M35.02,128.4 C35.810221,128.382422 36.5360569,127.960306 36.9421255,127.282171 C37.3481941,126.604036 37.3776012,125.764897 37.02,125.06 C35.8114229,122.875156 33.5168009,121.51368 31.02,121.5 L30,121.5 C28.1527416,121.473225 26.3718998,122.18835 25.0561895,123.485265 C23.7404793,124.782179 22.999806,126.552548 23,128.4 L35.02,128.4 Z"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M23,128.4 C23,124.589235 19.9107648,121.5 16.1,121.5 L14.96,121.5 C12.4643706,121.517898 10.1717177,122.878206 8.96,125.06 C8.6023988,125.764897 8.63180588,126.604036 9.03787449,127.282171 C9.4439431,127.960306 10.169779,128.382422 10.96,128.4 L23,128.4 Z"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="23"
              y1="128.4"
              x2="23"
              y2="111.16"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M43.7,74.36 L43.7,64 C43.7,52.5677057 34.4322943,43.3 23,43.3 C11.5677057,43.3 2.3,52.5677057 2.3,64 L2.3,74.36 L10.3,74.36 L10.3,85.86 C10.3,85.86 8.3,99.52 8.04,107.06 C7.97773219,108.129828 8.68192429,109.093901 9.72,109.36 C14.0336301,110.512593 18.475243,111.117351 22.94,111.16 C27.404757,111.117351 31.8463699,110.512593 36.16,109.36 C37.262026,109.16105 38.0478102,108.178819 38,107.06 C37.7,99.52 35.76,85.86 35.76,85.86 L35.76,74.36 L43.7,74.36 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <path
              id="Path"
              d="M43.7,74.36 L43.7,64 C43.7,52.5677057 34.4322943,43.3 23,43.3 C11.5677057,43.3 2.3,52.5677057 2.3,64 L2.3,74.36 L10.3,74.36 L10.3,85.86 C10.3,85.86 8.3,99.52 8.04,107.06 C7.97773219,108.129828 8.68192429,109.093901 9.72,109.36 C14.0336301,110.512593 18.475243,111.117351 22.94,111.16 C27.404757,111.117351 31.8463699,110.512593 36.16,109.36 C37.262026,109.16105 38.0478102,108.178819 38,107.06 C37.7,99.52 35.76,85.86 35.76,85.86 L35.76,74.36 L43.7,74.36 Z"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="10.36"
              y1="74.36"
              x2="10.36"
              y2="59.4"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="35.66"
              y1="74.36"
              x2="35.66"
              y2="59.4"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M10.36,74.36 L2.36,74.36 L2.36,92.18 C2.36,94.389139 4.150861,96.18 6.36,96.18 C8.569139,96.18 10.36,94.389139 10.36,92.18 L10.36,74.36 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M10.36,78.96 L2.36,78.96 C1.73967381,78.976188 1.13912636,78.7410326 0.694727397,78.3079319 C0.250328439,77.8748312 -0.000211183806,77.2805373 -8.86246955e-05,76.66 L-8.86246955e-05,76.66 C-0.00538916153,76.0483659 0.235200621,75.4602155 0.66770804,75.027708 C1.10021546,74.5952006 1.68836588,74.3546108 2.3,74.36 L10.3,74.36 L10.36,78.96 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <line
              id="Path"
              x1="23"
              y1="51.36"
              x2="23"
              y2="111.16"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <rect
              id="Rectangle"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round"
              x="10.36"
              y="78.96"
              width="25.3"
              height="6.9" />
            <circle
              id="Oval"
              class="fill-light"
              fill-rule="nonzero"
              cx="23"
              cy="82.4"
              r="4.6" />
            <path
              id="Path"
              d="M19.74,85.66 C17.9450746,83.8595517 17.9495517,80.9449254 19.75,79.15 C21.5504483,77.3550746 24.4650746,77.3595517 26.26,79.16 L19.74,85.66 Z"
              class="fill-white"
              fill-rule="nonzero" />
            <circle
              id="Oval"
              class="stroke"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              cx="23"
              cy="82.4"
              r="4.6" />
            <path
              id="Path"
              d="M31.46,94.0000111 L27.02,94.0000111 C26.3827874,94.0019891 25.7738184,93.7372279 25.3406617,93.2698745 C24.9075049,92.8025212 24.6896904,92.1752266 24.74,91.54 L25.7,77.9 L30.3,77.9 L31.46,94.0000111 Z"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M46.5,77.8 L30.3,77.8 L31.46,94.0000135 L44.84,94.0000135 C46.1175184,94.0030952 47.3387852,93.4747783 48.2112725,92.5415963 C49.0837598,91.6084142 49.5288749,90.3544269 49.44,89.08 L48.8,80 C48.7365069,78.7734797 47.7281301,77.8089453 46.5,77.8 Z"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M33.42,46.12 C31.9555204,45.2628546 30.3901904,44.5910391 28.76,44.12 L25.7,77.8 L30.3,77.8 L33.42,46.12 Z"
              class="stroke fill-light"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M43.7,74.36 L35.7,74.36 L35.7,92.18 C35.7,94.389139 37.490861,96.18 39.7,96.18 C41.909139,96.18 43.7,94.389139 43.7,92.18 L43.7,74.36 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M35.66,78.96 L43.66,78.96 C44.2768987,78.9707303 44.8722416,78.7331549 45.3122655,78.3006527 C45.7522894,77.8681506 46.0000886,77.276992 46.0000886,76.66 L46.0000886,76.66 C46.0053892,76.0483659 45.7647994,75.4602155 45.332292,75.027708 C44.8997845,74.5952006 44.3116341,74.3546108 43.7,74.36 L35.7,74.36 L35.66,78.96 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M16.12,44.48 L23,51.36 L29.88,44.48 C25.4283522,42.9061048 20.5716478,42.9061048 16.12,44.48 L16.12,44.48 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M30.2,54.26 L35.52,47.52 C33.8062197,46.2246806 31.9041711,45.1994629 29.88,44.48 L23,51.36 L27,54.56 C27.9744067,55.3347102 29.3865649,55.2023203 30.2,54.26 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
            <path
              id="Path"
              d="M15.8,54.26 L10.48,47.52 C12.1937803,46.2246806 14.0958289,45.1994629 16.12,44.48 L23,51.36 L19,54.56 C18.0255933,55.3347102 16.6134351,55.2023203 15.8,54.26 L15.8,54.26 Z"
              class="stroke fill-white"
              stroke-width="2"
              fill-rule="nonzero"
              stroke-linecap="round"
              stroke-linejoin="round" />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>
  @use '@/styles/variables.scss' as *;

  .fill-extra-light {
    fill: var(--iconColorFaded9);
  }

  .stroke {
    stroke: var(--iconColor);
  }

  .fill-light {
    fill: var(--iconColorFaded6);
  }

  .fill-white {
    fill: #ffffff;
  }
</style>
